/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_TimeInputs */

const en_form_time = /** @type {(inputs: Form_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const he_form_time = /** @type {(inputs: Form_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שעה`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Form_TimeInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_time = /** @type {((inputs?: Form_TimeInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_TimeInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_time(inputs)
	return he_form_time(inputs)
});